import { IdForm, IdFormData } from './id-form';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../../constants';
import IdFormBlank from '../../../shared/pdf-generation/pdf-pages/id-form/id-form-blank';
import { pdf } from '@react-pdf/renderer';

interface IdFormContainerProps {}

export const IdFormContainer: React.FC<IdFormContainerProps> = () => {

  const handleGeneratePdf = async (formData: IdFormData): Promise<File> => {
    console.log('Received form data:', formData);
    const combinedData = {
        caseId: formData?.caseId ?? undefined,
        dateOfBirth: formData.dateOfBirth,
        gender: formData.gender,
        restOfName: formData.firstName,
        lastName: formData.lastName,
        photoUrl: formData.photo,
        passportUrl: formData.expirationPhoto,
        submissionDeadline: dayjs().add(3, 'month').format(DATE_FORMAT)
    }
    console.log('Combined data:', combinedData);
    const pdfBlob = await pdf(<IdFormBlank data={combinedData} />).toBlob();
   return  new File([pdfBlob], 'id-form.pdf', { type: 'application/pdf' });
  };
  return (<IdForm generatePdf={handleGeneratePdf} />);
};
